import gql from 'graphql-tag';

export const PASSWORD_LOGIN = gql`
  mutation passwordLoginMutation($input: PasswordLoginInput) {
    passwordLogin(input: $input) {
      idToken
      refreshToken
    }
  }
`;

export const GENERATE_CODE = gql`
  mutation generateCodeMutation($emailOrPhone: String) {
    generateLoginCode(emailOrPhone: $emailOrPhone) {
      processed
    }
  }
`;

export const PASSWORDLESS_LOGIN = gql`
  mutation passwordlessLoginMutation($input: PasswordlessLoginInput) {
    passwordlessLogin(input: $input) {
      idToken
      refreshToken
    }
  }
`;

export const OAUTH_AUTHORIZATION = gql`
  mutation oauthAuthorizeMutation(
    $idToken: String
    $input: OauthAuthorizeInput!
  ) {
    oauthAuthorize(idToken: $idToken, input: $input) {
      redirectUri
    }
  }
`;

export const OAUTH_DENY = gql`
  mutation oauthDenyMutation($idToken: String, $input: OauthAuthorizeInput!) {
    oauthDeny(idToken: $idToken, input: $input) {
      redirectUri
    }
  }
`;
